import CreateInventoryItem from 'components/CreateInventoryItem';
import React from 'react';
import styles from './index.module.scss';

const CreateInventoryItemModal = props => {
  const {
    onCancel,
    onCreate,
    supplierId,
    populatedItemData,
  } = props;

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <CreateInventoryItem onCancel={onCancel} onCreate={onCreate} supplierId={supplierId} populatedItemData={populatedItemData} />
      </div>
    </div>
  );
};

export default CreateInventoryItemModal;
